'use client';
import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding-bottom: ${({ theme }) => theme.spacing(18)};
  max-width: 422px;
`;

export const Header = styled.h4`
  ${props => props.theme.typography.heading4}
  margin-bottom: ${({ theme }) => theme.spacing(10)};
  max-width: 350px;

  @media ${props => props.theme.mobileL} {
    max-width: 100%;
  }
`;
